module.exports = __webpack_public_path__ + "assets/tenBis-logo-4cce80.svg";